export class ContractNotFoundException extends Error {}
